export class InformacoesIndividuaisDeclaRenda {

    constructor(
        public cnpjCpf?: string,
        public nomeEmpresarial?: string,
        public cpf?: string,
        public nome?: string,
        public naturezaRendimento?: string,
        public nomeResponsavel?: string,
        public dataRespon?: String,
        public assinatura?: string
    ) {

    }

}



// WEBPACK FOOTER //
// /usr/src/app/src/app/area-restrita/shared/dominios/DTO/informacoes-individuais-decla-renda.ts